/**
 * @generated SignedSource<<1bf8c022099d899e3f556d5be2879470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type OfferType = "buy" | "rent";
export type PropertyMainType = "AGRI" | "APPT" | "BUILDING" | "COMMERCIAL" | "GARDEN" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "INDUS" | "OTHER" | "PARK" | "PROP" | "ROOM" | "SECONDARY";
export type PropertySearchNotification = "daily" | "never" | "weekly";
export type PropertyStatus = "existing" | "new";
export type PropertyUsage = "investment" | "primary" | "secondary";
export type SubscriptionStatus = "active" | "canceled" | "incomplete" | "incomplete_expired" | "past_due" | "trialing" | "unpaid";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
export type UpsertPropertySearchInput = {
  anonymousUserEmailAddress?: string | null;
  clientMutationId?: string | null;
  propertySearch?: PropertySearchInput | null;
};
export type PropertySearchInput = {
  activateAggregator?: boolean | null;
  aggregatorSource?: string | null;
  balconySurfaceGte?: number | null;
  builtSurfaceGte?: number | null;
  builtSurfaceLte?: number | null;
  comment?: string | null;
  filters?: AggregatesListingFiltersInput | null;
  financingPassportGte?: number | null;
  financingPassportLte?: number | null;
  gardenSurfaceGte?: number | null;
  hasBalcony?: boolean | null;
  hasFireplace?: boolean | null;
  hasGarage?: boolean | null;
  hasGarden?: boolean | null;
  hasLift?: boolean | null;
  hasParking?: boolean | null;
  hasSwimmingPool?: boolean | null;
  hasView?: boolean | null;
  id?: string | null;
  initCreatedAtGte?: boolean | null;
  isChildFriendly?: boolean | null;
  isFurnished?: boolean | null;
  isMinergieCertified?: boolean | null;
  isNewDevelopment?: boolean | null;
  isWheelchairAccessible?: boolean | null;
  landSurfaceGte?: number | null;
  landSurfaceLte?: number | null;
  livingSurfaceGte?: number | null;
  livingSurfaceLte?: number | null;
  monthlyRentGte?: number | null;
  monthlyRentLte?: number | null;
  notification?: PropertySearchNotification | null;
  numberOfBathroomsGte?: number | null;
  numberOfBathroomsLte?: number | null;
  numberOfBedroomsGte?: number | null;
  numberOfBedroomsLte?: number | null;
  numberOfIndoorParkingsGte?: number | null;
  numberOfOutdoorParkingsGte?: number | null;
  numberOfRoomsGte?: number | null;
  numberOfRoomsLte?: number | null;
  offerType?: OfferType | null;
  places?: ReadonlyArray<string> | null;
  propertyMainTypeIn?: ReadonlyArray<PropertyMainType> | null;
  propertyMainTypeNotIn?: ReadonlyArray<PropertyMainType> | null;
  propertyStatuses?: ReadonlyArray<PropertyStatus> | null;
  propertyTypes?: ReadonlyArray<string> | null;
  propertyUsage?: PropertyUsage | null;
  salePriceGte?: number | null;
  salePriceLte?: number | null;
  salePricePerLivingSurfaceGte?: number | null;
  salePricePerLivingSurfaceLte?: number | null;
  source?: string | null;
  userId?: string | null;
};
export type AggregatesListingFiltersInput = {
  agencyNames?: string | null;
  agencyReference_contains?: string | null;
  bookOnline_eq?: boolean | null;
  bounds?: InputGeoBounds | null;
  clusterIds_contains?: number | null;
  compositePropertyType_eq?: CompositePropertyType | null;
  createdAt_gte?: string | null;
  grossRentM2yearly_gte?: number | null;
  grossRentM2yearly_lte?: number | null;
  grossRentMonthly_gte?: number | null;
  grossRentMonthly_lte?: number | null;
  grossRentRoomMonthly_gte?: number | null;
  grossRentRoomMonthly_lte?: number | null;
  hasBalcony_eq?: boolean | null;
  hasElevator_eq?: boolean | null;
  hasFireplace_eq?: boolean | null;
  hasGarage_eq?: boolean | null;
  hasGarden_eq?: boolean | null;
  hasParking_eq?: boolean | null;
  hasView_eq?: boolean | null;
  id_eq?: string | null;
  id_in?: ReadonlyArray<string> | null;
  isChildFriendly_eq?: boolean | null;
  isFsbo_eq?: boolean | null;
  isFurnished_eq?: boolean | null;
  isMinergieCertified_eq?: boolean | null;
  isNewDevelopment_eq?: boolean | null;
  isWheelchairAccessible_eq?: boolean | null;
  landSurface_gte?: number | null;
  landSurface_lte?: number | null;
  livingSurface_gte?: number | null;
  livingSurface_lte?: number | null;
  numberOfRooms_gte?: number | null;
  numberOfRooms_lte?: number | null;
  offerType_eq: OfferType;
  placeSlugs?: ReadonlyArray<PlaceSlugInput | null> | null;
  placesById?: ReadonlyArray<PlaceInput | null> | null;
  portal_in?: ReadonlyArray<string | null> | null;
  salePricePerLandSurface_gte?: number | null;
  salePricePerLandSurface_lte?: number | null;
  salePricePerLivingSurface_gte?: number | null;
  salePricePerLivingSurface_lte?: number | null;
  salePrice_gte?: number | null;
  salePrice_lte?: number | null;
};
export type InputGeoBounds = {
  east: number;
  north: number;
  south: number;
  west: number;
};
export type PlaceInput = {
  objectId: string;
  type: TypeOfPlace;
};
export type PlaceSlugInput = {
  lang: LangInput;
  slug: string;
};
export type propertySearchDrawerUpsertMutation$variables = {
  input: UpsertPropertySearchInput;
};
export type propertySearchDrawerUpsertMutation$data = {
  readonly upsertPropertySearch: {
    readonly propertySearchEdge: {
      readonly node: {
        readonly activateAggregator: boolean;
        readonly builtSurfaceGte: number | null;
        readonly builtSurfaceLte: number | null;
        readonly canEditAlerts: boolean;
        readonly comment: string | null;
        readonly hasBalcony: boolean | null;
        readonly hasGarden: boolean | null;
        readonly hasLift: boolean | null;
        readonly hasParking: boolean | null;
        readonly hasSwimmingPool: boolean | null;
        readonly hasView: boolean | null;
        readonly id: string;
        readonly landSurfaceGte: number | null;
        readonly landSurfaceLte: number | null;
        readonly livingSurfaceGte: number | null;
        readonly livingSurfaceLte: number | null;
        readonly monthlyRentGte: number | null;
        readonly monthlyRentLte: number | null;
        readonly notification: PropertySearchNotification;
        readonly numberOfBathroomsGte: number | null;
        readonly numberOfBathroomsLte: number | null;
        readonly numberOfBedroomsGte: number | null;
        readonly numberOfBedroomsLte: number | null;
        readonly numberOfRoomsGte: number | null;
        readonly numberOfRoomsLte: number | null;
        readonly offerType: OfferType;
        readonly places: ReadonlyArray<{
          readonly breadcrumbs: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
          readonly label: string;
          readonly lat: number;
          readonly lng: number;
          readonly objectId: string;
          readonly population: number | null;
          readonly type: TypeOfPlace;
        }> | null;
        readonly propertyMainTypeIn: ReadonlyArray<PropertyMainType> | null;
        readonly propertyStatuses: ReadonlyArray<PropertyStatus>;
        readonly propertyTypes: ReadonlyArray<{
          readonly id: string;
          readonly label: string | null;
          readonly mainType: string | null;
        }> | null;
        readonly propertyUsage: PropertyUsage | null;
        readonly salePriceGte: number | null;
        readonly salePriceLte: number | null;
        readonly source: string | null;
        readonly user: {
          readonly firstName: string | null;
          readonly id: string;
          readonly lastName: string | null;
          readonly organisation: {
            readonly formattedAddress: string | null;
            readonly name: string | null;
          } | null;
          readonly primaryEmail: {
            readonly email: string;
          } | null;
          readonly primaryImage: {
            readonly url: string;
          } | null;
          readonly subscription: {
            readonly status: SubscriptionStatus;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"userSummary_user">;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type propertySearchDrawerUpsertMutation = {
  response: propertySearchDrawerUpsertMutation$data;
  variables: propertySearchDrawerUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Place",
  "kind": "LinkedField",
  "name": "places",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "population",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "incudeNonIndexed",
          "value": true
        }
      ],
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": "breadcrumbs(incudeNonIndexed:true)"
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePriceLte",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePriceGte",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyRentLte",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyRentGte",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyUsage",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyStatuses",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRoomsGte",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRoomsLte",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBedroomsGte",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBedroomsLte",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathroomsGte",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathroomsLte",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurfaceGte",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurfaceLte",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "builtSurfaceGte",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "builtSurfaceLte",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurfaceGte",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurfaceLte",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyType",
  "kind": "LinkedField",
  "name": "propertyTypes",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyMainTypeIn",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSwimmingPool",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLift",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasParking",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasGarden",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBalcony",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasView",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notification",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activateAggregator",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canEditAlerts",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "primaryEmail",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referrer",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBroker",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "propertySearchDrawerUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertPropertySearchPayload",
        "kind": "LinkedField",
        "name": "upsertPropertySearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PropertySearchConnectionEdge",
            "kind": "LinkedField",
            "name": "propertySearchEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertySearch",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Email",
                        "kind": "LinkedField",
                        "name": "primaryEmail",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "primaryImage",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organisation",
                        "kind": "LinkedField",
                        "name": "organisation",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Subscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "userSummary_user"
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "propertySearchDrawerUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertPropertySearchPayload",
        "kind": "LinkedField",
        "name": "upsertPropertySearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PropertySearchConnectionEdge",
            "kind": "LinkedField",
            "name": "propertySearchEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertySearch",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organisation",
                        "kind": "LinkedField",
                        "name": "organisation",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Subscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhoneNumber",
                        "kind": "LinkedField",
                        "name": "phoneNumbers",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "number",
                            "storageKey": null
                          },
                          (v50/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Email",
                        "kind": "LinkedField",
                        "name": "emails",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v50/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "broker",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v45/*: any*/),
                          (v44/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12d3fe4e30745ec2ef266d8182952009",
    "id": null,
    "metadata": {},
    "name": "propertySearchDrawerUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation propertySearchDrawerUpsertMutation(\n  $input: UpsertPropertySearchInput!\n) {\n  upsertPropertySearch(input: $input) {\n    propertySearchEdge {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          primaryEmail {\n            email\n            id\n          }\n          primaryImage {\n            url\n            id\n          }\n          organisation {\n            name\n            formattedAddress\n            id\n          }\n          subscription {\n            status\n            id\n          }\n          ...userSummary_user\n        }\n        places {\n          id\n          type\n          objectId\n          lat\n          lng\n          label\n          population\n          breadcrumbs(incudeNonIndexed: true) {\n            id\n          }\n        }\n        offerType\n        salePriceLte\n        salePriceGte\n        monthlyRentLte\n        monthlyRentGte\n        propertyUsage\n        propertyStatuses\n        numberOfRoomsGte\n        numberOfRoomsLte\n        numberOfBedroomsGte\n        numberOfBedroomsLte\n        numberOfBathroomsGte\n        numberOfBathroomsLte\n        livingSurfaceGte\n        livingSurfaceLte\n        builtSurfaceGte\n        builtSurfaceLte\n        landSurfaceGte\n        landSurfaceLte\n        propertyTypes {\n          id\n          label\n          mainType\n        }\n        propertyMainTypeIn\n        hasSwimmingPool\n        hasLift\n        hasParking\n        hasGarden\n        hasBalcony\n        hasView\n        notification\n        activateAggregator\n        comment\n        source\n        canEditAlerts\n      }\n    }\n  }\n}\n\nfragment userAvatar_user on User {\n  id\n  firstName\n  lastName\n  primaryImage {\n    url\n    id\n  }\n  primaryEmail {\n    email\n    id\n  }\n  referrer\n  isBroker\n  isAdmin\n}\n\nfragment userSummary_user on User {\n  ...userAvatar_user\n  id\n  displayName\n  organisation {\n    id\n    name\n  }\n  phoneNumbers {\n    formattedNumber\n    number\n    primary\n    id\n  }\n  emails {\n    email\n    primary\n    id\n  }\n  broker {\n    ...userAvatar_user\n    id\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c43faeba4bcb0532b72e7ade73ec290";

export default node;
